// 💳 Packs SMS additionnels — MIROIR de config/appee.php (sms_packs).
// Source unique côté front : importé par le wizard campagne ET la popup SMS.
export const SMS_PACKS = [
  { credits: 50,   price: 9 },
  { credits: 100,  price: 16 },
  { credits: 500,  price: 69 },
  { credits: 1000, price: 119 },
];

// En dessous de ce solde, on propose un rachat (marge SMS → pousser à la vente)
export const SMS_LOW_THRESHOLD = 20;

// Pack recommandé pour couvrir un manque donné (le plus petit qui suffit)
export function recommendedPack(missing) {
  const idx = SMS_PACKS.findIndex(p => p.credits >= missing);
  return idx === -1 ? SMS_PACKS.length - 1 : idx;
}
